var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-block"},[_c('button',{staticClass:"buttonClasses",on:{"click":_vm.reset}},[_c('label',{attrs:{"for":"ResetPosition"}},[_vm._v(_vm._s(_vm.$t("simulator.ResetPosition")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }